import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgramParticipantsPreview(
    $organizationId: Int!
    $complianceProgramId: Int
    $steps: [ComplianceProgramStepInput]
    $assessmentTemplates: [AssessmentTemplateComplianceRequirement]
    $calibration: ComplianceProgramCalibrationType
    $ongoing: Boolean
    $startDateOffset: Int
    $appliesTo: ComplianceProgramAppliesTo
    $appliesToTeams: [Int]
    $appliesToManagers: [Int]
    $appliesToUsers: [Int]
    $excludedUsers: [Int]
    $excludedHireDateAfter: Date
    $removeExcludedHireDateAfter: Boolean
  ) {
    complianceProgramParticipantsPreview(
      organizationId: $organizationId
      complianceProgramId: $complianceProgramId
      steps: $steps
      assessmentTemplates: $assessmentTemplates
      calibration: $calibration
      ongoing: $ongoing
      startDateOffset: $startDateOffset
      appliesTo: $appliesTo
      appliesToTeams: $appliesToTeams
      appliesToManagers: $appliesToManagers
      appliesToUsers: $appliesToUsers
      excludedUsers: $excludedUsers
      excludedHireDateAfter: $excludedHireDateAfter
      removeExcludedHireDateAfter: $removeExcludedHireDateAfter
    ) {
      participantCount
      participants {
        user {
          id
          name
          avatar
        }
        manager {
          id
          name
        }
      }
      warnings {
        reason
        message
        users {
          id
          name
          avatar
        }
      }
    }
  }
`;
